// extracted by mini-css-extract-plugin
module.exports = {"arrowLink":"F_b9","arrowLeft":"F_cP","arrowRight":"F_cQ"};